"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAdapter = void 0;
const utils_1 = require("@unifiprotocol/utils");
class BaseAdapter {
    constructor(blockchainConfig) {
        this.blockchainConfig = blockchainConfig;
        this.address = "";
    }
    getTxLink(hash) {
        return this.blockchainConfig.explorer.tx(hash);
    }
    getAddressLink(hash) {
        return this.blockchainConfig.explorer.address(hash);
    }
    getTokenLink(hash) {
        return this.blockchainConfig.explorer.token(hash);
    }
    setAddress(address) {
        this.address = address;
    }
    getAddress() {
        return this.address;
    }
    sanitizeBlock(block) {
        if (utils_1.BN(block).isNaN()) {
            return block;
        }
        return Number(block);
    }
}
exports.BaseAdapter = BaseAdapter;
